import React, { useState } from "react";
import close from "../../../../static/ic-close.svg";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { openCloseAboutUs, openCloseOrderHistory, openCloseWithdraw } from "../../../../Redux/actions/actionNames";
import Button from "../../../../design-system/lib/Button";
import Typography from "../../../../design-system/lib/Typography";
import Maincss from "./main.module.css";

class App extends React.Component {

  openOrderHistory=()=>{
    this.props.dispatch(openCloseWithdraw(false))
  }

  render() {
    return (
      <div className="OrderListHeader" style={{borderBottom:"1px solid #F4F4F7"}}>
        <img onClick={this.openOrderHistory} src={close} className="OrderListHeaderClose" />
        <span className="OrderListHeaderTitle">
          <Trans i18nKey={"Withdraw"}>
          </Trans>
        </span>

        <Typography weight="Body_Middle_Bold" onClick={()=>{this.props.onnewWithdrawDialoge()}} text={"Request widthdraw"} className={Maincss.Requestwidthdraw} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
